import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const adminPanel = {
    path: '/adminPanel',
    component: Layout,
    name: 'adminPanels',
    redirect: '/adminPanel/index',
    children: [
        {
            path: '/adminPanel/index',
            component: () => import('@/views/adminPanel/index'),
            name: 'adminPanel.index',
            meta: { title: i18n.t(`message.admin_commands`)}
        },
    ]
}

export default adminPanel